<template>
  <div
    id="sitemap"
    class="z3 border-right"
    :style="{
      backgroundColor: currentSubdomain
        ? currentSubdomain.acf.background_colour
        : 'white',
    }"
  >
    <div class="sitemap-wrapper" :class="{ 'with-top-margin': !isHome }">
      <div class="logo-wrapper mb2" v-if="showLogo">
        <router-link :to="{ name: 'Investigations' }">
          <img class="logo" src="/forensic-architecture-logo.svg" />
        </router-link>
      </div>

      <router-link to="/"><h2>Investigations</h2></router-link>
      <ul class="list-reset mt0 caps">
        <li><router-link to="/">All</router-link></li>
        <li>
          <span @click="toggleCategories()" class="pointer hover-red"
            >By Category</span
          >
          <ul v-if="showCategories" class="mb2 list-reset">
            <li
              class="pl2"
              v-for="category in investigationCategories"
              :key="category.term_id"
            >
              <router-link
                :to="{
                  name: 'Investigation Category',
                  params: {
                    slug: category.slug,
                  },
                }"
                >{{ category.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <span @click="toggleMethodologies()" class="pointer hover-red"
            >By Methodology</span
          >
          <ul v-if="showMethodologies" class="mb2 list-reset">
            <li
              class="pl2"
              v-for="methodology in investigationMethodologies"
              :key="methodology.id"
            >
              <router-link
                :to="{
                  name: 'Investigation Methodology',
                  params: {
                    slug: methodology.slug,
                  },
                }"
                >{{ methodology.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <span @click="toggleLocations()" class="pointer hover-red"
            >By Location</span
          >
          <ul v-if="showLocations" class="mb2 list-reset">
            <li
              class="pl2"
              v-for="location in investigationLocations"
              :key="location.code"
            >
              <router-link
                :to="{
                  name: 'Investigation Location',
                  params: {
                    slug: location.slug,
                  },
                }"
                >{{ location.name }}</router-link
              >
            </li>
          </ul>
        </li>
        <li><a @click.prevent="toggleDaMap()" href="/map">Map</a></li>
        <!-- <li class="studies&#45;separator"><router&#45;link :to="{ name: 'Studies' }">Studies</router&#45;link></li> -->
      </ul>

      <router-link :to="{ name: 'Exhibitions' }"
        ><h2 class="red">Programme</h2></router-link
      >
      <ul class="list-reset mt0 caps">
        <li>
          <router-link :to="{ name: 'Exhibitions' }">Exhibitions</router-link>
        </li>
        <!-- <li><router-link :to="{ name: 'Programme', params: { page: 'academy' }}">Academy</router-link></li> -->
        <li><router-link :to="{ name: 'Events' }">Events</router-link></li>
        <li><router-link :to="{ name: 'News' }">News</router-link></li>
        <li>
          <router-link :to="{ name: 'Publications' }">Publications</router-link>
        </li>
      </ul>

      <router-link :to="{ name: 'About', params: { page: 'agency' } }"
        ><h2 class="red">About</h2></router-link
      >
      <ul class="list-reset mt0 caps">
        <li>
          <router-link :to="{ name: 'About', params: { page: 'agency' } }"
            >Agency</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'Team' }">Team</router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'About', params: { page: 'advisory-board' } }"
            >Advisory Board</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'About', params: { page: 'funding' } }"
            >Funding</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'About', params: { page: 'recognition' } }"
            >Recognition</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'About', params: { page: 'jobs' } }"
            >Jobs</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'About', params: { page: 'press' } }"
            >Press</router-link
          >
        </li>
        <li>
          <a href="https://contact.forensic-architecture.org">Contact</a>
        </li>

        <li>
          <router-link class="uppercase" style="color: var(--red);" :to="{ name: 'Donate' }" >Support Us</router-link>
        </li>
      </ul>

      <h2 class="red">Subdomains</h2>
      <ul class="list-reset mt0 caps">
        <li v-for="subdomain in orderedSubdomains" :key="subdomain.ID">
          <router-link
            :to="{ name: 'Subdomain', params: { subdomain: subdomain.slug } }"
            >{{ subdomain.title.rendered }}</router-link
          >
        </li>
      </ul>

      <!-- TODO: Dark mode extra feature -->
      <!-- <span class="dark-mode-button pointer hover-red" @click="darkMode()">Aa</span> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "SiteMap",

  data() {
    return {
      aboutLine: "",
      showCategories: false,
      showLocations: false,
      showMethodologies: false,
    };
  },

  computed: {
    ...mapState([
      "aboutLines",
      "investigationCategories",
      "investigationLocations",
      "investigationMethodologies",
      "subdomains",
    ]),
    showLogo() {
      return !this.$route.meta.logo;
    },
    currentSubdomain() {
      if (!this.subdomains) return null;
      const domain = this.subdomains.filter((x) => {
        return x.slug === this.$route.params.subdomain;
      });
      if (domain.length == 1) {
        return domain[0];
      } else {
        return null;
      }
    },
    orderedSubdomains() {
      return this.subdomains.slice().sort((a, b) => {
        if (a.slug > b.slug) return 1;
        else if (b.slug > a.slug) return -1;
        return 0;
      });
    },
    isHome() {
      return this.$route.path === "/";
    },
  },

  methods: {
    ...mapActions(["toggleMap"]),
    toggleDaMap() {
      this.$emit("close");
      this.toggleMap();
    },
    toggleCategories() {
      this.showLocations = false;
      this.showMethodologies = false;
      this.showCategories = !this.showCategories;
    },
    toggleLocations() {
      this.showCategories = false;
      this.showMethodologies = false;
      this.showLocations = !this.showLocations;
    },
    toggleMethodologies() {
      this.showCategories = false;
      this.showLocations = false;
      this.showMethodologies = !this.showMethodologies;
    },
    darkMode() {
      document.body.classList.add("dark");
      document.documentElement.style.setProperty("--col-light", "rgb(16,16,16");
      document.documentElement.style.setProperty("--black", "rgb(150,150,150)");
    },
  },

  watch: {
    $route() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="css" scoped>
@import "../css/variables";



#sitemap {
  z-index: 9998;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  background: var(--col-light);
  max-width: 350px;
  border-color: var(--red);
  line-height: var(--line-height-m);

  &::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }
  /* optional: show position indicator in red */
  &::-webkit-scrollbar-thumb {
    background: #ff0000;
  }

  /* width */
  &::-webkit-scrollbar {
    width: 0;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: var(--red);
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--red);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: var(--red);
  }

  h2 {
    display: inline-block;
    margin-bottom: 0.25em;
    color: red;
  }

  .sitemap-wrapper {
    margin-left: 1em;
    margin-top: 3em;
    margin-right: 1em;

    &.with-top-margin {
      margin-top: 6em;
    }
  }

  a {
    &:hover {
      color: var(--red);
    }

    &.boxy:hover {
      background: var(--col-light);
      color: var(--red);
    }
  }
}

.logo-wrapper {
  line-height: normal;
  top: auto;

  h1.logo {
    display: inline-block;
  }
}

.credit {
  position: fixed;
  bottom: 1em;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}

.dark-mode-button {
  background: rgb(16, 16, 16);
  color: rgb(150, 150, 150);
  padding: 6px;
  border-radius: 50%;
  font-size: var(--font-size-s);
  margin-top: 3em;
  position: absolute;
  bottom: 1em;
  left: 1em;
  height: 1.4em;
  width: 1.4em;
  text-align: center;
  opacity: 0.6;
  transition: all 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }
}

.studies-separator {
  border-top: 1px solid #efefef;
  padding-top: 0.3em;
  margin-top: 0.3em;
}

@media (--phone) {
  #sitemap {
    overflow: scroll;
  }
}
</style>
